export const SidebarIdGlobalProductsSettings = 'GLOBAL_PRODUCTS_SETTINGS' as const;
